export default __webpack_public_path__ + "static/media/atlantaFalconsVideo-2x.6f60b388.jpg";